module.exports = __webpack_public_path__ + "static/4_2_recommendation_PL-c5f343b7f58bb61108523eadeb46f08c.svg";